import React, { useCallback, useState } from 'react'
import { useNavigate, useParams } from 'react-router'
import { useTranslation } from 'react-i18next'
import { AppTitlePage } from 'components/AppTitlePage'
import AppBtn, {
  AppBtnColor,
  AppBtnSize,
  IconPosition,
} from 'components/btn/AppBtn'

import { AppTabsBlock } from 'shared/ui/AppTabsBlock'
import FileUploadDishAIPopup from './components/FileUploadDishAIPopup'
import { MainTab } from './components/MainTab'
import { InfoTab } from './components/InfoTab'
import { PriceHistoryTab } from './components/PriceHistoryTab'
import { useCanEditPrice } from './hooks/useCanEditPrice'

export enum DetailTab {
  'main' = 'main',
  'info' = 'info',
  'priceHistory' = 'priceHistory',
}

export const CreateDishPage = () => {
  const { dishId } = useParams()
  const { t } = useTranslation()
  const canEditPrice = useCanEditPrice()

  const [isDirty, setIsDirty] = useState(false)

  const [activeTab, setActiveTab] = useState<DetailTab>(DetailTab.main)
  const setActiveTabHandler = useCallback(
    (value: DetailTab) => setActiveTab(value),
    [],
  )

  const [aiUploadActive, setAiUploadActive] = useState(false)

  const isEdit = Boolean(dishId)

  return (
    <React.Fragment>
      <div
        className={`width-for-page-wrapper ${
          dishId ? 'edit-dishes-page' : 'create-dishes-page'
        }`}
      >
        <div className="heading-with-import">
          <AppTitlePage
            title={`${dishId ? 'Редактирование' : 'Добавление'} блюда`}
            goBack
            isDirty={isDirty}
          />
          {isEdit && activeTab === DetailTab.info && (
            <AppBtn
              color={AppBtnColor.violetWhite}
              title={'Импорт'}
              sized={AppBtnSize.md}
              iconClassName={'add'}
              onClick={() => setAiUploadActive(true)}
            />
          )}
        </div>
        {isEdit ? (
          <AppTabsBlock<DetailTab>
            tabs={[
              { name: t('Основное'), value: DetailTab.main },
              { name: t('Справочник AI'), value: DetailTab.info },
              ...(canEditPrice
                ? [
                    {
                      name: t('История стоимости'),
                      value: DetailTab.priceHistory,
                    },
                  ]
                : []),
            ]}
            activeTab={activeTab}
            setActiveTab={setActiveTabHandler}
            className="width-100 top-20"
            underBlock={null}
          >
            {activeTab === DetailTab.main && <MainTab />}
            {activeTab === DetailTab.info && <InfoTab />}
            {activeTab === DetailTab.priceHistory && canEditPrice && (
              <PriceHistoryTab />
            )}
          </AppTabsBlock>
        ) : (
          <MainTab />
        )}
      </div>
      {aiUploadActive && (
        <FileUploadDishAIPopup
          setIsDirty={setIsDirty}
          onClose={() => setAiUploadActive(false)}
        />
      )}
    </React.Fragment>
  )
}
